import React from 'react';
import './HeroSection.css'; // Create this CSS file next

const HeroSection = () => {
  return (
    <section className="hero-section">
      <div className="container">
        <div className="hero-content">
          <h1>Expert in Web Development and Branding</h1>
          <p>Our team specializes in creating fantastic web designs and positive brand identities.</p>
          {/* You can add a button here that scrolls to the pricing section */}
          <a href="#choose-a-plan" className="btn btn-primary">SEE PLANS</a>
        </div>
      </div>
    </section>
  );
};

export default HeroSection; 